import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3 12.3a9.3 9.3 0 1116.6 5.9l5.1 5a1 1 0 01-1.4 1.5l-5.1-5.1A9.3 9.3 0 013 12.3zm14.6 5.2a1 1 0 00-.1 0A7.3 7.3 0 015 12.4a7.3 7.3 0 1112.6 5.2z" fill="currentColor" /></svg>);